export const REQUEST_FOR_APPRAISERS_CHANGE = 'Request for appraisers change';

export const POTENTIAL_END_DATE_HIGHLIGHT_MESSAGE = {
  SELF: 'The potential end date has expired. Please contact your PM',
  ACTION_TAKER: 'The potential end date has expired. Please take necessary action.',
};

export const ROSTER_BUTTON_TEXT = 'View detail roster';
